/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  GuangGaoZhuShenQingChaXunTiaoJian,
  GuangGaoZhuShenQingRuZhuXinXi,
  GuangGaoZhuShenQingShenHeXinXi,
  ResponseApiGuangGaoZhuShenQingXiangQing,
  ResponseApiIPageGuangGaoZhuShenQingXiangQing,
  ResponseApiString,
  ResponseApiVoid,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class GuangGaoZhuShenQingRuZhuGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags GuangGaoZhuShenQingRuZhuGuanLi
   * @name AuditApplyUsingPost
   * @summary 审核申请
   * @request POST:/dsp-admin/api/advertiser-apply/audit
   * @secure
   */
  auditApplyUsingPost = (
    auditDTO: GuangGaoZhuShenQingShenHeXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiVoid, void>({
      path: `/dsp-admin/api/advertiser-apply/audit`,
      method: "POST",
      body: auditDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuShenQingRuZhuGuanLi
   * @name ListAppliesUsingPost
   * @summary 分页查询申请列表
   * @request POST:/dsp-admin/api/advertiser-apply/list
   * @secure
   */
  listAppliesUsingPost = (
    queryDTO: GuangGaoZhuShenQingChaXunTiaoJian,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageGuangGaoZhuShenQingXiangQing, void>({
      path: `/dsp-admin/api/advertiser-apply/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuShenQingRuZhuGuanLi
   * @name SubmitApplyUsingPost
   * @summary 提交广告主入驻申请
   * @request POST:/dsp-admin/api/advertiser-apply/submit
   * @secure
   */
  submitApplyUsingPost = (
    createDTO: GuangGaoZhuShenQingRuZhuXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiString, void>({
      path: `/dsp-admin/api/advertiser-apply/submit`,
      method: "POST",
      body: createDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GuangGaoZhuShenQingRuZhuGuanLi
   * @name GetApplyDetailUsingPost
   * @summary 获取申请详情
   * @request POST:/dsp-admin/api/advertiser-apply/{id}
   * @secure
   */
  getApplyDetailUsingPost = (id?: number, params: RequestParams = {}) =>
    this.request<ResponseApiGuangGaoZhuShenQingXiangQing, void>({
      path: `/dsp-admin/api/advertiser-apply/${id}`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new GuangGaoZhuShenQingRuZhuGuanLi();
